import { use, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ReusableModal from "../../../components/Models/ReusableModal";
import FormicForm from "../../../Extracomponents/Newformicform";
import { useFormik } from "formik";
import Content from "../../../components/Contents/Content";
import {
  GetUserData,
  DeleteDematAccount,
  UpdateBroker,
  GetActiveBrokerList,
} from "../../../Services/UserService/User";
import BrokersData from "../../../../Utils/BrokersData";
import { base_url } from "../../../../Utils/config";
import { Eye } from "lucide-react";
import showCustomAlert from "../../../Extracomponents/CustomAlert/CustomAlert";

const Demat = () => {
  const [brokers, setBrokers] = useState([]);

  const BROKER_METADATA = {
    "angle": { id: 1, name: "Angel One", img: "https://play-lh.googleusercontent.com/Ic8lUYwMCgTePpo-Gbg0VwE_0srDj1xD386BvQHO_mOwsfMjX8lFBLl0Def28pO_Mvk" },
    "angelone": { id: 1, name: "Angel One", img: "https://play-lh.googleusercontent.com/Ic8lUYwMCgTePpo-Gbg0VwE_0srDj1xD386BvQHO_mOwsfMjX8lFBLl0Def28pO_Mvk" },
    "aliceblue": { id: 2, name: "Alice Blue", img: "https://media.licdn.com/dms/image/v2/D560BAQHU88VqPp14_w/company-logo_200_200/company-logo_200_200/0/1714714585811/alice_blue_financial_services_ltd_logo?e=2147483647&v=beta&t=-wlK1PYJutu-1MibN_iR2-i5Vga7VWuckKi0jOQp2F0" },
    "kotakneo": { id: 3, name: "Kotak Neo", img: "https://yt3.googleusercontent.com/yM-KyoT9t4jHt8-cqgi_tU0MqbDV6LhgNo7mQkvN8nTsMegf_D1qDwIGYzbWNYUOkgnW7jVuhYA=s900-c-k-c0x00ffffff-no-rj" },
    "markethub": { id: 4, name: "Market Hub", img: "https://media.licdn.com/dms/image/v2/D560BAQEB5MsFZkdKwg/company-logo_200_200/company-logo_200_200/0/1681292585114/market_hub_stock_broking_pvt_ltd__logo?e=1746057600&v=beta&t=9YGrMbiPySe_qefvVi7OuaBOhjgc-BbupTeRPPIp1jE" },
    "zerodha": { id: 5, name: "Zerodha", img: "https://media.licdn.com/dms/image/D4D12AQGJnj8j3sb2TQ/article-cover_image-shrink_720_1280/0/1683270116246?e=2147483647&v=beta&t=H0c3cHnPKzjoiJVSlrKlWw0gD_6I4rnWHGYwVOhrPTs" },
    "upstox": { id: 6, name: "Upstox", img: "https://website-assets-fd.freshworks.com/attachments/clogvv27a034uwzoavav3omzt-featured-img-copy2.full.png" },
    "dhan": { id: 7, name: "Dhan ", img: "https://play-lh.googleusercontent.com/lVXf_i8Gi3C7eZVWKgeG8U5h_kAzUT0MrmvEAXfM_ihlo44VEk01HgAi6vbBNsSzBQ" }
  };

  const [showModal, setShowModal] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [userDetail, setUserDetail] = useState();
  const [dlinkstatus, setDlinkstatus] = useState(false);
  const [brokerData, setBrokerData] = useState({});
  const [viewmodel, setViewModel] = useState(false);

  const token = localStorage.getItem("token");
  const userid = localStorage.getItem("id");

  useEffect(() => {
    getuserdetail();
    fetchActiveBrokers();
  }, []);

  const fetchActiveBrokers = async () => {
    try {
      const response = await GetActiveBrokerList(token);
      if (response.status && response.data) {
        const activeBrokers = response.data.map(broker => {
          const key = (broker.title || broker.name || "").toLowerCase().replace(/\s/g, "");
          const meta = BROKER_METADATA[key] || {};
          return {
            ...broker,
            id: meta.id || broker.broker_id || broker.id || broker._id,
            name: meta.name || broker.title || broker.name,
            img: broker.image || meta.img || "/assets/images/default-broker.png"
          };
        });
        setBrokers(activeBrokers);
      }
    } catch (error) {
      console.log("Error fetching active brokers", error);
    }
  };

  const DeleteDematAccountApi = async () => {
    const result = await showCustomAlert(
      "confirm",
      "Are You Sure to Want To Remove Demat",
    );
    if (result.isConfirmed) {
      try {
        const response = await DeleteDematAccount({ id: userid }, token);
        if (response.status) {
          showCustomAlert(
            "Deleted!",
            "Your account has been deleted.",
            "success",
          );
          getuserdetail();
        } else {
          showCustomAlert("error", response.message || "Something went wrong.");
        }
      } catch (error) {
        showCustomAlert("error", "Failed to delete account. Try again later.");
      } finally {
        window.location.reload();
      }
    }
  };

  const getuserdetail = async () => {
    try {
      const response = await GetUserData(userid, token);
      if (response.status) {
        setUserDetail(response.data?.brokerid);
        setDlinkstatus(response.data?.dlinkstatus == 1);
        setBrokerData(response.data);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  const handleBrokerLinking = async (UserDetail) => {
    try {
      const data = {
        brokerid: UserDetail.brokerid,
        apikey: UserDetail.apikey,
        apisecret: UserDetail.apisecret,
        id: UserDetail._id,
      };

      const response = await UpdateBroker(data, UserDetail.token);
      if (response?.status) {
        showCustomAlert("success", "Broker linked successfully!");
        window.location.reload();
      } else {
        showCustomAlert("error", response?.message || "Something went wrong");
      }
    } catch (error) {
      showCustomAlert("error", "Broker linking failed");
      console.error("UpdateBroker error:", error);
    }
  };

  const handleShowModal = async (title) => {
    setModalTitle(title);
    if (brokerData.dlinkstatus == 0) {
      setViewModel(true);
    } else {
      if (brokerData.brokerid === 1) {
        window.location.href = `https://smartapi.angelone.in/publisher-login?api_key=${brokerData.apikey}`;
      } else if (brokerData.brokerid == 2) {
        window.location.href = `https://ant.aliceblueonline.com/?appcode=${brokerData.apikey}`;
      } else if (brokerData.brokerid == 3) {
      } else if (brokerData.brokerid == 4) {
      } else if (brokerData.brokerid == 5) {
        window.location.href = `https://kite.zerodha.com/connect/login?v=3&api_key=${brokerData.apikey};`;
      } else if (brokerData.brokerid == 6) {
        // window.location.href = `https://api-v2.upstox.com/login/authorization/dialog?response_type=code&client_id=${brokerData.apikey}&redirect_uri=https://${base_url}/backend/upstox/getaccesstoken&state=${brokerData.Email};`;
        window.location.href = `https://api-v2.upstox.com/login/authorization/dialog?response_type=code&client_id=${brokerData.apikey}&redirect_uri=${base_url}upstox/getaccesstoken&state=${brokerData.Email};`;
      } else if (brokerData.brokerid == 7) {
        await handleBrokerLinking(brokerData);
      }
    }
  };

  const closeBrokerModal = () => {
    setViewModel(false);
  };

  const handleBrokerClick = (broker) => {
    if (!brokerData?.Email) {
      showCustomAlert("error", "Please Complete The Profile");
      return;
    }

    handleShowModal(broker?.name);
    setUserDetail(broker?.id);
  };

  return (
    <div>
      <Content
        Page_title="Supported Broker"
        button_status={false}
        backbutton_status={false}
      >
        <div className="page-content d-block">
          <div className="demate-data row row-cols-1 row-cols-lg-2 row-cols-xl-4 justify-content-center align-items-center">
            {brokers.length > 0 ? (
              brokers?.map((broker) => (
                <div className="col-md-3 col-sm-6 mb-5" key={broker?.id}>
                  <div className="card-wrap">
                    <div className="card-header one">
                      <img
                        className="img-fluid"
                        src={broker?.img}
                        alt={broker?.name}
                      />
                    </div>
                    <div className="card-content">
                      <h5 className="mb-2 mt-3">{broker?.name}</h5>

                      {brokerData?.dlinkstatus == 0 ? (
                        <>
                          <button
                            className="btn btn-sm btn-primary"
                            onClick={() => handleBrokerClick(broker)}
                          >
                            <i className="fa fa-eye text-dark"></i> View
                          </button>
                        </>
                      ) : brokerData?.brokerid == broker?.id ? (
                        <>
                          <button
                            className="btn btn-sm btn-success"
                            // onClick={() => {
                            //   handleShowModal(broker?.name);
                            //   setUserDetail(broker?.id);
                            // }}
                          >
                            Active
                          </button>
                          <button
                            className="btn btn-sm btn-danger mt-1"
                            onClick={(e) => DeleteDematAccountApi()}
                          >
                            Remove
                          </button>
                        </>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="text-center mt-5">
                <img
                  src="/assets/images/nodata.png"
                  alt="No Records Found"
                  className="w-25"
                />
              </div>
            )}

            {viewmodel && (
              <BrokersData
                closeModal={closeBrokerModal}
                type={userDetail}
                data={brokerData}
              />
            )}
          </div>
        </div>
      </Content>
    </div>
  );
};

export default Demat;
